import React from 'react';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import {
  SubscriptionCallout,
  SubscriptionAccent,
  SubscriptionContent,
} from './Subscription.styles';
import { useNavigate } from 'react-router-dom';

const Subscription = () => {
  const navigate = useNavigate();
  return (
    <SubscriptionCallout>
      <SubscriptionAccent>
        <span>Subscription Service</span>
      </SubscriptionAccent>

      <SubscriptionContent>
        <div>
          <p className="eyebrowHeader">Digital Safety Forms</p>

          <h2>Contact Us for Subscription Pricing</h2>

          <p>
            Digital safety forms are offered as a subscription service. Pricing
            can depend on your company&apos;s needs and the forms you want
            available, so contact our team to discuss the best setup for your
            workplace.
          </p>
        </div>
        <PrimaryButtonComponent
          span="Contact Our Team"
          functionName={() => navigate('/contact-us')}
        />
      </SubscriptionContent>
    </SubscriptionCallout>
  );
};

export default Subscription;
